import React from 'react';
import { ReactComponent as PdfIcon } from "assets/img/svg/pdfIcon.svg"
import { downLoadFile } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/common';

export const refundDetails = [
    { key: "rectificationReason", label: "Rectification reason" },
    { key: "paymentMode", label: "Paymode *" },
    { key: "attachments", label: "Attachments" },
    { key: "psid", label: "PSID" },
    { key: "correctApplicationId", label: "Correct Application ID" },
    { key: "remark", label: "Remarks" },
];

export const negativeReceiptDetails = [
    { key: "orderType", label: "Refund Type" },
    { key: "subOrderType", label: "Paymode *" },
    { key: "supportingDocKey", label: "Supporting Doc *" },
    { key: "remark", label: "Remarks" },
];

export const newStudentDetails = [
    { key: "newStudentName", label: "Student name" },
    { key: "correctPsid", label: "Correct PSID" },
    { key: "newTermValue", label: "Term" },
    { key: "newRegularCourseId", label: "Course ID" },
    { key: "newBusinessAreaValue", label: "BU" },
];

export const sampleReceiptDetail = {
    rectificationReason: ["Incorrect PSID", "Incorrect App ID"],
    paymode: "Cash",
    s3Key: ["Request form.pdf"],
    psid: "00004208326",
    correctAppId: "1234567890",
    remarks: "Incorrect PISD",

    studentName: "Shlok Nikhil",
    correctPsid: "12345678901",
    term: "2325",
    courseId: "71003",
    businessArea: "JP001",
};

export const displayFile = (file) => {
    if (!file?.length) return <>-</>;

    return (
        <div
            className="d-flex align-items-center p-1"
            style={{ background: "#F5F5F5", borderRadius: "8px", width: '170px' }}
        >
            <PdfIcon height={20} />
            <div
                className="cursor"
                style={{ margin: '7px 0px 6px 0px', textDecoration: "underline" }}
                onClick={() => downLoadFile(true, file)}
            >
                Attachment
            </div>
        </div>
    );
};
